import { IDataProvider } from "@/store";

export interface IReportFile {
  name: string;
  guid: string;
}

export interface IReportFileState {
  reportFile: IReportFile | null;
  reportFiles: IReportFile[] | null;
  dataProvider: IDataProvider<IReportFile>;
}

export const state: IReportFileState = {
  reportFile: null,
  reportFiles: null,
  dataProvider: {
    items: [],
    pager: {
      buttonsToShow: 3,
      currentPage: 1,
      endPage: 1,
      startPage: 1,
      totalPages: 1,
    },
  },
};
